import { Item } from './item.model';
import sumBy from 'lodash-es/sumBy';
import { TaxBreakDown } from './taxbreakdown.model';
import { StoreConfig } from '../interfaces/store-config.interface';
import { MemberVatAndDiscountInfo } from '../interfaces/member-vat-discount.interface';
import { MemberLevel } from '../enums/member-level.enum';
import { environment } from 'src/environments/environment';
export class Cart {
    id: number;
    sessionGuid: string;
    cartTypeId: number;
    memberId: number;
    purchaseFlowId: number;
    items: Array<Item> = [];
    totalTax: number;
    shippingCost: number;
    totalPoints: number;
    shippingTax: number;
    isShippingTaxInclusive: boolean;
    itemsCount: number;
    tax: number;
    total: number;
    subTotal: number;
    savedPrice: number;
    taxBreakDown: TaxBreakDown;
    store: StoreConfig;
    rowStateId?: number;

    constructor(cartInfo: Cart, store: StoreConfig, shippingCost?: number, taxAmount?: number, taxInclusive?: boolean,
                memberVatAndDiscountInfo?: MemberVatAndDiscountInfo) {
        if (cartInfo) {
            this.id = cartInfo.id;
            this.sessionGuid = cartInfo.sessionGuid;
            this.cartTypeId = cartInfo.cartTypeId;
            this.memberId = cartInfo.memberId;
            this.purchaseFlowId = cartInfo.purchaseFlowId;
            this.items = cartInfo.items;
            this.totalTax = this.calculateItemsTotalTax();
            this.shippingCost = this.calculateShippingCost(shippingCost);
            this.shippingTax = 0;
            this.isShippingTaxInclusive = cartInfo.isShippingTaxInclusive;
            this.itemsCount = this.count();
            this.tax = taxAmount;
            this.subTotal = this.calculateItemsSubTotal(store, taxInclusive, memberVatAndDiscountInfo);
            this.total = this.calculateItemsTotal(store, taxInclusive, memberVatAndDiscountInfo);
            this.totalPoints = this.calculateTotalPoints();
            this.savedPrice = this.calculateSavedPrice();
        }
    }

    /**
     * returns total shipping tax
     */
    calculateShippingCost(shippingCost: number = 0): number {
        return shippingCost;
    }

    /**
     * calculate saved price
     */
    calculateSavedPrice(): number {
        let savedPrice = 0;
        for (let i = 0; i < this.items.length; i++) {
            savedPrice += (this.items[i].retailPrice * this.items[i].quantity) - (this.items[i].applicablePrice * this.items[i].quantity);
        }
        if (this.store) {
            savedPrice = Number(savedPrice.toFixed(Math.max(0, ~~this.store.numberDecimals)));
        }
        return savedPrice;
    }

    /**
     * Get Total CartItems Cost.
     */
    calculateItemsSubTotal(store: StoreConfig, taxInclusive: boolean, memberVatAndDiscountInfo?: MemberVatAndDiscountInfo): number {
        let itemsSubTotal = 0;
        for (let i = 0; i < this.items.length; i++) {
            if (memberVatAndDiscountInfo && store.taxInclusive) {
              itemsSubTotal += this.calculateSubtotalForVatAndNonVatRegisteredUser(this.items[i], store,
                taxInclusive, memberVatAndDiscountInfo);
            } else {
                itemsSubTotal += this.calculateItemSubtotal(this.items[i], store, taxInclusive);
            }
          }
        if (this.store) {
            itemsSubTotal = Number(itemsSubTotal.toFixed(Math.max(0, ~~store.numberDecimals)));
        }
        return itemsSubTotal;
    }

    /**
   * calculate subtotal for vat and not vat registered user
   * calculateSubtotalForVatAndNonVatRegisteredUser()
   */
  calculateSubtotalForVatAndNonVatRegisteredUser(item: Item, store: StoreConfig, taxInclusiveShippingCountry: boolean,
                                                 memberVatAndDiscountInfo?: MemberVatAndDiscountInfo): number {
    if (!item.literature && (memberVatAndDiscountInfo.taxCalculated || !memberVatAndDiscountInfo.vatRegistered)) {
        if (memberVatAndDiscountInfo.transactionalOptin &&
            memberVatAndDiscountInfo.transactionalWholesaleQualified
            && (memberVatAndDiscountInfo.memberTitleId > MemberLevel.ASSISTANTSUPERVISOR
                || (memberVatAndDiscountInfo.memberTitleId === MemberLevel.ASSISTANTSUPERVISOR
                    && !memberVatAndDiscountInfo.enableWHLSAL00ForAsstSupervisor))) {
            // return (item[memberVatAndDiscountInfo.vatRegistered ? 'baseWholesalePrice' : 'wholesalePrice'] * item.quantity) -
            //   (item.baseRetailPrice * (memberVatAndDiscountInfo.discountPercentage / 100) * item.quantity);
            const total = Number(item[(memberVatAndDiscountInfo.vatRegistered || !taxInclusiveShippingCountry)
                ? 'catalogPrice' : 'computedTaxInclusivePrice']);
                return (Math.round((total + Number.EPSILON) * 100) / 100) * item.quantity;
          } else {
            return Number(item[memberVatAndDiscountInfo.vatRegistered ? 'catalogPrice' : 'applicablePrice'].
              // tslint:disable-next-line:no-bitwise
              toFixed(Math.max(0, ~~(store && store.numberDecimals ? store.numberDecimals : 2)))) * item.quantity;
          }
    } else if (item.literature && memberVatAndDiscountInfo.vatRegistered && memberVatAndDiscountInfo.taxCalculated) {
      return Number(item.catalogPrice.
        // tslint:disable-next-line:no-bitwise
        toFixed(Math.max(0, ~~(store && store.numberDecimals ? store.numberDecimals : 2)))) * item.quantity;
    } else {
      return this.calculateItemSubtotal(item, store, taxInclusiveShippingCountry);
    }
  }

    /**
    * calculate subtotal
    * calculateItemSubtotal()
    */
    calculateItemSubtotal(item: Item, store: StoreConfig, taxInclusive: boolean): number {
        return Number(item[(taxInclusive === false) ? 'catalogPrice' : 'applicablePrice'].
            // tslint:disable-next-line:no-bitwise
            toFixed(Math.max(0, ~~(store && store.numberDecimals ? store.numberDecimals : 2)))) * item.quantity;
    }


    /**
     * Get total points
     */
    calculateTotalPoints(): number {
        let _totalCV = 0;
        for (let i = 0; i < this.items.length; i++) {
            _totalCV += this.items[i].CV * this.items[i].quantity;
        }
        return _totalCV;
    }

    /**
     * returns all the items total tax
     */
    calculateItemsTotalTax(): number {
        return sumBy(this.items, 'tax');
    }


    /**
     * get total amount of items
     */
    calculateItemsTotal(store: StoreConfig, taxInclusive: boolean, memberVatAndDiscountInfo?: MemberVatAndDiscountInfo): number {
        let totalCost = 0;
        let itemsTotalTax = 0;
        for (let i = 0; i < this.items.length; i++) {
            if (!taxInclusive) {
                itemsTotalTax += this.items[i].tax;
            }
        }
        let shipTax: number = this.shippingTax;
        // Skip shipping tax if shipping tax is inclusive
        if (this.isShippingTaxInclusive === false) {
            shipTax = this.shippingTax;
        }
        if (memberVatAndDiscountInfo && memberVatAndDiscountInfo.vatRegistered
            && memberVatAndDiscountInfo.taxCalculated && taxInclusive) {
            totalCost = this.subTotal + (this.shippingCost || 0) + this.tax + (shipTax || 0);
          } else {
            totalCost = this.subTotal + (this.shippingCost || 0) + ((taxInclusive === false) ? (this.tax || 0) : 0) + (shipTax || 0);
          }
        if (store) {
            totalCost = Number(totalCost.toFixed(Math.max(0, ~~store.numberDecimals)));
        }
        return totalCost;
    }

    /**
     * returns the number of items in the cart
  */
    count(): number {
        let totalQty = 0;
        if (this.items) {
            for (let i = 0; i < this.items.length; i++) {
                totalQty += this.items[i].quantity;
            }
        }
        return totalQty;
    }
}
